import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { FaBell, FaBars, FaMoon, FaSun, FaSearch, FaHome } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { toggleDarkMode } from '../../redux/slices/uiSlice';

const AdminHeader = ({ sidebarOpen, setSidebarOpen }) => {
  const { user } = useSelector((state) => state.auth);
  const { darkMode } = useSelector((state) => state.ui);
  const dispatch = useDispatch();

  return (
    <header className="sticky top-0 z-30 bg-white/80 dark:bg-slate-900/80 backdrop-blur-xl border-b border-slate-100 dark:border-slate-800">
      <div className="px-4 md:px-6 py-3 flex justify-between items-center gap-4">
        <div className="flex items-center gap-4">
          <button
            onClick={() => setSidebarOpen(!sidebarOpen)}
            className="lg:hidden w-9 h-9 flex items-center justify-center rounded-xl text-slate-600 dark:text-slate-400 hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors"
          >
            <FaBars size={16} />
          </button>

          <div className="hidden sm:block">
            <h1 className="text-lg font-semibold text-slate-900 dark:text-white">
              Welcome back, <span className="text-gradient">{user?.name?.split(' ')[0] || 'Admin'}</span>
            </h1>
            <p className="text-xs text-slate-500 dark:text-slate-400 mt-0.5">
              Here's what's happening today
            </p>
          </div>
        </div>

        {/* Search bar - hidden on mobile */}
        <div className="hidden md:flex items-center gap-2 bg-slate-50 dark:bg-slate-800/80 rounded-xl px-4 py-2 flex-1 max-w-sm border border-slate-100 dark:border-slate-700/50">
          <FaSearch className="text-slate-400 text-sm" />
          <input
            type="text"
            placeholder="Search anything..."
            className="bg-transparent outline-none flex-1 text-sm text-slate-700 dark:text-slate-200 placeholder:text-slate-400 dark:placeholder:text-slate-500"
          />
        </div>

        <div className="flex items-center gap-2">
          {/* Visit storefront */}
          <Link
            to="/"
            className="hidden sm:flex items-center gap-2 px-3 py-2 rounded-xl text-xs font-medium text-slate-600 dark:text-slate-400 hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors"
          >
            <FaHome size={12} />
            <span>View Store</span>
          </Link>

          {/* Dark mode toggle */}
          <button
            onClick={() => dispatch(toggleDarkMode())}
            className="w-9 h-9 flex items-center justify-center rounded-xl text-slate-600 dark:text-slate-400 hover:bg-slate-100 dark:hover:bg-slate-800 transition-all duration-300"
          >
            {darkMode ? <FaSun size={15} className="text-amber-500" /> : <FaMoon size={15} />}
          </button>



          {/* User profile */}
          <div className="flex items-center gap-3 ml-1 pl-3 border-l border-slate-100 dark:border-slate-800">
            <div className="w-9 h-9 rounded-xl bg-gradient-to-br from-primary-500 to-primary-700 text-white flex items-center justify-center text-sm font-bold shadow-md shadow-primary-500/20">
              {user?.name?.charAt(0)?.toUpperCase() || 'A'}
            </div>
            <div className="hidden md:block">
              <p className="text-sm font-semibold text-slate-800 dark:text-white leading-tight">{user?.name || 'Admin'}</p>
              <p className="text-[11px] text-slate-500 dark:text-slate-400 capitalize">{user?.role || 'admin'}</p>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default AdminHeader;